import { Controller } from 'stimulus';

export default class extends Controller {
  contentArrayBuffer;
  worldName;
  seed;

  processData(event) {
    event.preventDefault();
    const modifierElement = document.getElementById('modifiers');
    let data = modifierElement.getAttribute("data");
    if (data) {
      const dataBytes = Uint8Array.from(atob(data), c => c.charCodeAt(0));
      this.contentArrayBuffer = dataBytes.buffer;
      this.hideTrigger();
      this.showModifiers();
      this.processBinaryContent();
    }
  };

  processFile(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.contentArrayBuffer = e.target.result;
        this.processBinaryContent();
        this.showModifiers();
      };
      reader.readAsArrayBuffer(file);
    }
  };

  processBinaryContent() {
    const uint8Array = new Uint8Array(this.contentArrayBuffer);
    const textDecoder = new TextDecoder('utf-8');
    const decodedString = textDecoder.decode(uint8Array);
    
    const lines = decodedString.split('\n');
    const parsedData = this.parseKeyValuePairs(decodedString);
    
    const nameElement = document.getElementById("worldname");
    const seedElement = document.getElementById('seed');
    const combatElement = document.getElementById('combat');
    const deathPenaltyElement = document.getElementById('deathpenalty');
    const resourceRateElement = document.getElementById('resourcerate');
    const raidRateElement = document.getElementById('raidrate');
    const portalsElement = document.getElementById('portals');
    const noBuildCostElement = document.getElementById('nobuildcost');
    const playerRaidsElement = document.getElementById('playerraids');
    const passiveEnemiesElement = document.getElementById('passiveenemies');
    const noMapElement = document.getElementById('nomap');
  
    const combat = this.getCombatValue(parsedData["playerdamage"]);
    const deathPenalty = this.getDeathPenaltyValue(lines[0], parsedData["skillreductionrate"]);
    const resourceRate = this.getResourceRateValue(parsedData["resourcerate"]);
    const raidRate = this.getRaidRateValue(parsedData["eventrate"]);
    const portals = this.getPortalsValue(lines[0]);
  
    const noBuildCost = lines.some(line => line.includes('nobuildcost')) ? 1 : 0;
    const playerRaids = lines.some(line => line.includes('playerevents')) ? 1 : 0;
    const passiveEnemies = lines.some(line => line.includes('passivemobs')) ? 1 : 0;
    const noMap = lines.some(line => line.includes('nomap')) ? 1 : 0;
  
    combatElement.value = combat;
    deathPenaltyElement.value = deathPenalty;
    resourceRateElement.value = resourceRate;
    raidRateElement.value = raidRate;
    portalsElement.value = portals;
    noBuildCostElement.checked = noBuildCost === 1;
    playerRaidsElement.checked = playerRaids === 1;
    passiveEnemiesElement.checked = passiveEnemies === 1;
    noMapElement.checked = noMap === 1;

    const nameRegex = /[\n\r]*[\x20-\x7E]+[\n\r]+/g;

    let nameMatches = [];
    let nameMatch;

    while ((nameMatch = nameRegex.exec(decodedString)) !== null) {
      nameMatches.push(nameMatch[0].trim());
    };

    this.worldName = nameMatches[0];

    const seedRegex = /[a-zA-Z0-9]{10}/g;
    const seedArray = decodedString.match(seedRegex) || [];

    this.seed = seedArray[0]
    nameElement.textContent = this.worldName;
    seedElement.textContent = this.seed;
  };

  parseKeyValuePairs(text) {
    const keyValuePairs = {};
    text.replace(/(\w+) (\d+)/g, (match, key, value) => {
      keyValuePairs[key] = parseInt(value);
    });
    return keyValuePairs;
  }

  getCombatValue(value) {
    const combatMapping = {
      125: 'veryeasy',
      110: 'easy',
      85: 'hard',
      70: 'veryhard'
    };
    return combatMapping[value] || 'normal';
  };

  getDeathPenaltyValue(line, value) {
    if (value === 15) {
      return line.includes("deathkeepequip") ? 'casual' : 'veryeasy';
    }
    const deathPenaltyMapping = {
      50: 'easy',
      150: 'hard',
      'deathpenalty_hard': 'hard'
    };
    return deathPenaltyMapping[value] || (line.includes("deathdeleteitems") ? 'hardcore' : 'normal');
  };

  getResourceRateValue(value) {
    const resourceRateMapping = {
      50: '0.5',
      75: '0.75',
      150: '1.5',
      200: '2',
      300: '3'
    };
    return resourceRateMapping[value] || 'normal';
  };

  getRaidRateValue(value) {
    const raidRateMapping = {
      200: 'muchless',
      150: 'less',
      60: 'more',
      30: 'muchmore',
      0: 'none'
    };
    return raidRateMapping[value] || 'normal';
  };

  getPortalsValue(line) {
    if (line.includes("teleportall")) {
      return 'portalitems';
    } else if (line.includes("nobossportals")) {
      return 'noboss';
    } else if (line.includes("noportals")) {
      return 'none';
    }
    return 'normal';
  };

  hideTrigger() {
    const triggerElement = document.getElementById('trigger')
    if (triggerElement) {
      triggerElement.style.display = 'none';
    };
  };

  showModifiers() {
    const modifiersElement = document.getElementById('modifiers');
    if (modifiersElement) {
      modifiersElement.style.display = 'flex';
    };
  };

  getPrecedingCharacter(string) {
    let stringLength = string.length;
    let char = String.fromCharCode(stringLength)
    return `${char}${string}`
  };

  getByteLength(lenghtInput) {
    let lengthBytes;
    if (lenghtInput <= 256) {
      lengthBytes = 1;
    } else if (lenghtInput <= 65536) {
      lengthBytes = 2;
    } else if (lenghtInput <= 16777216) {
      lengthBytes = 3;
    } else {
      lengthBytes = 4;
    }
    return lengthBytes
  }

  editFileContent() {
    const combatValue = document.getElementById('combat').value;
    const deathPenaltyValue = document.getElementById('deathpenalty').value;
    const resourceRateValue = document.getElementById('resourcerate').value;
    const raidRateValue = document.getElementById('raidrate').value;
    const portalsValue = document.getElementById('portals').value;
    const noBuildCostValue = document.getElementById('nobuildcost').checked;
    const playerRaidsValue = document.getElementById('playerraids').checked;
    const passiveEnemiesValue = document.getElementById('passiveenemies').checked;
    const noMapValue = document.getElementById('nomap').checked;
    let preset = 'preset ';
    let metaString = '';
    let metaCount = 0;

    // Construct the final output as binary data
    const fileNameBytes = new TextEncoder().encode(this.worldName);
    const fileNameLength = fileNameBytes.length;

    const seedBytes = new TextEncoder().encode(this.seed);
    const seedLength = seedBytes.length;
  
    // Extract the filler data as raw binary bytes
    const fillerStart = 10 + fileNameLength + seedLength;
    let desiredFillerLength = 17;
    while (fillerStart + desiredFillerLength >= this.contentArrayBuffer.byteLength) {    
      // Reduce desiredFillerLength until true
      desiredFillerLength -= 1;
    }
    const filler = new Uint8Array(this.contentArrayBuffer, fillerStart, desiredFillerLength);

    const combatMapping = {
      'veryeasy': [`${this.getPrecedingCharacter("playerdamage 125")}${this.getPrecedingCharacter("enemydamage 50")}${this.getPrecedingCharacter("enemyspeedsize 90")}`, 3],
      'easy': [`${this.getPrecedingCharacter("playerdamage 110")}${this.getPrecedingCharacter("enemydamage 75")}${this.getPrecedingCharacter("enemyspeedsize 95")}`, 3],
      'hard': [`${this.getPrecedingCharacter("playerdamage 85")}${this.getPrecedingCharacter("enemydamage 150")}${this.getPrecedingCharacter("enemyspeedsize 110")}${this.getPrecedingCharacter("enemyleveluprate 120")}`, 4],
      'veryhard': [`${this.getPrecedingCharacter("playerdamage 70")}${this.getPrecedingCharacter("enemydamage 200")}${this.getPrecedingCharacter("enemyspeedsize 120")}${this.getPrecedingCharacter("enemyleveluprate 140")}`, 4]
    };

    if (combatValue !== 'normal') {
      metaString += combatMapping[combatValue][0];
      metaCount += combatMapping[combatValue][1];
      preset += `combat_${combatValue}:`;
    } else {
      preset += "combat_default:";
    };

    const deathPenaltyMapping = {
      'casual': [`${this.getPrecedingCharacter("deathkeepequip")}${this.getPrecedingCharacter("skillreductionrate 15")}`, 2],
      'veryeasy': [`${this.getPrecedingCharacter("skillreductionrate 15")}`, 1],
      'easy': [`${this.getPrecedingCharacter("skillreductionrate 50")}`, 1],
      'hard': [`${this.getPrecedingCharacter("deathdeleteunequipped")}${this.getPrecedingCharacter("skillreductionrate 150")}`, 2],
      'hardcore': [`${this.getPrecedingCharacter("deathdeleteitems")}${this.getPrecedingCharacter("deathskillsreset")}`, 2]
    };

    if (deathPenaltyValue !== 'normal') {
      metaString += deathPenaltyMapping[deathPenaltyValue][0];
      metaCount += deathPenaltyMapping[deathPenaltyValue][1];
      preset += `deathpenalty_${deathPenaltyValue}:`;
    } else {
      preset += "deathpenalty_default:";
    };

    const resourceRateMapping = {
      '0.5': [this.getPrecedingCharacter("resourcerate 50"), "muchless"],
      '0.75': [this.getPrecedingCharacter("resourcerate 75"), "less"],
      '1.5': [this.getPrecedingCharacter("resourcerate 150"), "more"],
      '2': [this.getPrecedingCharacter("resourcerate 200"), "muchmore"],
      '3': [this.getPrecedingCharacter("resourcerate 300"), "most"]
    };

    if (resourceRateValue !== 'normal') {
      metaString += resourceRateMapping[resourceRateValue][0];
      metaCount += 1;
      preset += `resources_${resourceRateMapping[resourceRateValue][1]}:`;
    } else {
      preset += "resources_default:";
    };

    const raidRateMapping = {
      'none': this.getPrecedingCharacter("eventrate 0"),
      'muchless': this.getPrecedingCharacter("eventrate 200"),
      'less': this.getPrecedingCharacter("eventrate 150"),
      'more': this.getPrecedingCharacter("eventrate 60"),
      'muchmore': this.getPrecedingCharacter("eventrate 30")
    };
    
    if (raidRateValue !== 'normal') {
      metaString += raidRateMapping[raidRateValue];
      metaCount += 1;
      preset += `raids_${raidRateValue}:`;
    } else {
      preset += "raids_default:";
    };

    if (portalsValue === 'portalitems') {
      metaString += this.getPrecedingCharacter("teleportall");
      metaCount += 1;
      preset += "portals_casual";
    } else if (portalsValue === 'noboss') {
      metaString += this.getPrecedingCharacter("nobossportals");
      metaCount += 1;
      preset += "portals_hard";
    } else if (portalsValue === 'none') {
      metaString += this.getPrecedingCharacter("noportals");
      metaCount += 1;
      preset += "portals_veryhard";
    } else {
      preset += "portals_default";
    };

    if (noBuildCostValue) {
      metaString += this.getPrecedingCharacter("nobuildcost");
      metaCount += 1;
    }; 
    if (playerRaidsValue) {
      metaString += this.getPrecedingCharacter("playerevents");
      metaCount += 1;
    };
    if (passiveEnemiesValue) {
      metaString += this.getPrecedingCharacter("passivemobs");
      metaCount += 1;
    };
    if (noMapValue) {
      metaString += this.getPrecedingCharacter("nomap")
      metaCount += 1;
    };
    
    let presetBytes = [];
    if (preset) {
      presetBytes = new TextEncoder().encode(this.getPrecedingCharacter(preset));
    }
    
    let presetLength = 0; // Initialize presetLength to 0
    if (presetBytes) {
      presetLength = presetBytes.length;
    }
    
    const metaBytes = new TextEncoder().encode(metaString);
    const metaBytesLength = metaBytes.length;
    
    const totalLength = 4 + 1 + fileNameLength + 1 + seedLength + filler.length + 4 + metaBytesLength + presetLength;    

    // Calculate the total length including the initial byte for length
    
    let offset = 0;

    const output = new Uint8Array(4 + totalLength);

    let lengthBytes = this.getByteLength(totalLength);

    // Add the length bytes
    for (let i = lengthBytes - 1; i >= 0; i--) {
      output[offset++] = (totalLength >> (8 * i));
    }

    for (let i = 0; i < 4 - lengthBytes; i++) {
      output[offset++] = 0x00;
    }

    output.set([0x20, 0x00, 0x00, 0x00], offset);
    offset += 4;

    // Add the fileName length bytes
    output[offset++] = fileNameLength;

    // Add the fileName bytes
    output.set(fileNameBytes, offset);
    offset += fileNameLength;

    // Add the seed length bytes
    output[offset++] = seedLength;

    // Add the seed
    output.set(seedBytes, offset);
    offset += seedLength;

    // Add the filler bytes
    output.set(filler, offset);
    offset += filler.length;

    let metaLengthBytes = this.getByteLength(metaCount);

    // Add the length bytes
    for (let i = metaLengthBytes - 1; i >= 0; i--) {
      output[offset++] = (metaCount >> (8 * i));
    }

    for (let i = 0; i < 4 - metaLengthBytes; i++) {
      output[offset++] = 0x00;
    }

    // Add the metadata
    output.set(metaBytes, offset);
    offset += metaBytesLength;

    output.set(presetBytes, offset);
    offset += presetLength;

    // Create a new Uint8Array with the exact length
    const finalOutput = new Uint8Array(output.length);

    // Copy the data from the original output to the final output
    finalOutput.set(output.subarray(0, output.length));

    return finalOutput;
  }

  downloadEditedFile(event) {
    event.preventDefault();
    const editedFileData = this.editFileContent();
    const blob = new Blob([editedFileData], { type: 'application/octet-stream' });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `${this.worldName}.fwl`;
    downloadLink.click();
  }

  uploadToServer(event) {
    event.preventDefault();
    const dataInput = document.getElementById('data_param');
    const data = this.editFileContent();
    const encoded_data = this.arrayBufferToBase64(data);
    const form = document.getElementById('uploadform');
    dataInput.value = encoded_data;
    form.submit();
  }

  v2UploadToServer(event) {
    event.preventDefault();
    const dataInput = document.getElementById('data_param');
    let modifiers = "";
    let setkeys = "";
    const combatValue = document.getElementById('combat').value;
    const deathPenaltyValue = document.getElementById('deathpenalty').value;
    const resourceRateValue = document.getElementById('resourcerate').value;
    const raidRateValue = document.getElementById('raidrate').value;
    const portalsValue = document.getElementById('portals').value;
    const noBuildCostValue = document.getElementById('nobuildcost').checked;
    const playerRaidsValue = document.getElementById('playerraids').checked;
    const passiveEnemiesValue = document.getElementById('passiveenemies').checked;
    const noMapValue = document.getElementById('nomap').checked;
    const resourceRateMapping = {
      '0.5': "muchless",
      '0.75': "less",
      '1.5': "more",
      '2': "muchmore",
      '3': "most"
    };
    const portalsMapping = {
      'portalitems': "casual",
      'noboss': "hard",
      'none': "veryhard"
    };
    if (combatValue != 'normal') {
      modifiers += `combat ${combatValue} `
    }
    if (deathPenaltyValue != 'normal') {
      modifiers += `deathpenalty ${deathPenaltyValue} `
    }
    if (resourceRateValue != 'normal') {
      modifiers += `resources ${resourceRateMapping[resourceRateValue]} `
    }
    if (raidRateValue != 'normal') {
      modifiers += `raids ${raidRateValue} `
    }
    if (portalsValue != 'normal') {
      modifiers += `portals ${portalsMapping[portalsValue]}`
    }
    if (noBuildCostValue) {
      setkeys += "nobuildcost "
    }
    if (playerRaidsValue) {
      setkeys += "playerevents "
    }
    if (passiveEnemiesValue) {
      setkeys += "passivemobs"
    }
    if (noMapValue) {
      setkeys += "nomap"
    }

    const form = document.getElementById('uploadform');
    let jsonData = JSON.stringify({ modifiers: modifiers, setkeys: setkeys })
    dataInput.value = jsonData;
    form.submit();
  }

  arrayBufferToBase64(arrayBuffer) {
    // Convert ArrayBuffer to Uint8Array
    const uint8Array = new Uint8Array(arrayBuffer);

    // Create a binary string from the Uint8Array
    let binaryString = '';
    uint8Array.forEach((byte) => {
        binaryString += String.fromCharCode(byte);
    });

    // Encode the binary string as Base64
    return btoa(binaryString);
  }
}
